import { ProductWithAnalytics } from '../../store/products/types';
import { Summary } from '../../store/summary/types';
import {
  ProductEntity,
  ProductId,
  ProductName
} from '../../store/types';

export type TAnaliticProductProps = {
  item_id: ProductId;
  item_price?: number;
  item_name?: ProductName;
  item_prescription_type?: string;
  item_delivery_type?: string;
  item_is_in_stock?: boolean;
  item_added_from?: string;
  item_removed_from?: string;
  item_serp_position?: number | string;
  item_suggest_position?: number | string;
  search_query?: string | string;
  item_button_type?: string;
  item_is_online_recipe?: boolean;
  item_tooltip_quantity?: boolean;
  parent_analogues_is_in_stock?: boolean | string;
  item_is_vmt?: boolean;
  item_is_stm?: boolean;
  item_brand?: string;
  item_quantity?: number;
  item_category?: string;
  item_is_isg?: boolean;
  item_is_preorder?: boolean;
  estimated_days_to_pickup?: number;
  recipe_source?: number | string;
  newQuantity?: number;
  item_rating?: number;
};

export type TAnaliticProductsProps = {
  item_id: ProductId[];
  item_name: ProductName[];
  item_price: number[];
  item_prescription_type: string[];
  item_delivery_type: string[];
  item_is_in_stock: boolean[];
  item_is_online_recipe: boolean[];
  item_is_vmt?: boolean[];
  item_is_stm?: boolean[];
  item_is_isg?: boolean[];
  item_brand?: string[];
  item_category?: string[];
  item_quantity?: number[];
  item_is_preorder: boolean[];
  item_rating?: number[];
  estimated_days_to_pickup?: number[];
};

export type TAnaliticCartProps = {
  summary: Summary;
  products: ProductEntity<ProductWithAnalytics>;
  product?: ProductWithAnalytics;
  isCartInstallmentAvailable?: boolean;
  newQuantity?: number;
  isOnlineRecipeClient?: number;
  isActiveOnlineRecipeClient?: boolean;
};

export type TAnaliticProductRemovedProps =
  TAnaliticCartProps & {
    buttonType?: string;
  };

export type TAnaliticCartViewedProps =
  TAnaliticProductsProps & {
    quantity: number;
    revenue: number;
    discount: number;
    delivery_info: string;
    recipe_source: number[];
    promo_discount: number[];
    is_online_recipe_client: number;
    is_active_online_recipe_client: boolean;
    cart_updated: boolean;
  };

export type TAnaliticCartSubmitClickedProps =
  TAnaliticProductsProps & {
    quantity: number;
    revenue: number;
    discount: number;
    delivery_info: string;
    bnpl_availability: string;
  };

export type TAnaliticInstallmentProps = {
  id: ProductId[];
  item_name: ProductName[];
  item_price: number[];
  cart_price: number;
  page: string;
};

export type TAnaliticAddedToCartProps =
  TAnaliticProductProps;

export type TAnaliticCartCleanedProps =
  TAnaliticProductsProps & {
    quantity: number;
    revenue: number;
    discount: number;
  };

export type TAnaliticRecommendationShownProps = {
  block_type: string;
  item_id: ProductId[];
  item_price?: number[];
  item_rating?: number[];
};

export enum RemoveProductButton {
  minus = 'minus',
  manual = 'manual',
  cartClearButton = 'cart_clear_button'
}
